const FINANCEIRO = ['valorTotal', 'valorPago', 'dataPagamento', 'payed']

export function sanitizeForCheckin(participant) {
  if (!participant) return participant
  const out = { ...participant }
  for (const f of FINANCEIRO) delete out[f]
  return out
}

export function sanitizeForRole(participant, role) {
  if (role !== 'CHECKIN') return participant
  return sanitizeForCheckin(participant)
}
